
import store from '@/store'
import { checkWebUserSparksLimit } from '@/api/svip'
import { REQUEST_SUCCESS_CODE } from '@/config/constant'
import { $loading } from '@/utils'

let checkUserChatNeedSubscriptionTot: ReturnType<typeof setTimeout> | null = null

export const checkUserChatNeedSubscription = async (params: any, options: { abortController?: AbortController } = {}) => {
    const userInfo = store.getters['user/userInfo']

    if (userInfo?.subscriedInfo?.subscribed) {
        return {
            show: false
        }
    }

    try {
        checkUserChatNeedSubscriptionTot = setTimeout(() => {
            $loading.loading()
            checkUserChatNeedSubscriptionTot = null
        }, 1000)

        let checkOriginRes

        // 转换参数：把 actionCode 等转换为新接口需要的 points、siteId、functionCode
        const sparksParams = {
            site_id: 'sovi_web',
            function_code: params?.functionCode || 'ask_sovi'
        }

        checkOriginRes = await checkWebUserSparksLimit(sparksParams, {
            abortController: options.abortController
        })

        if (checkOriginRes.code == REQUEST_SUCCESS_CODE) {
            const checkRes = checkOriginRes.data

            // sufficient=true: 余额充足，不显示付费墙
            if (checkRes.sufficient === true) {
                return {
                    show: false
                }
            }

            // sufficient=false: 余额不足，显示付费墙
            // 构造原来的返回格式，保证流程不变
            return {
                show: true,
                showAfterAnswer: false,
                paywallConfig: {
                    paywallMode: 'pay_normal',
                    paywallCheckParams: params
                },
                paywallList: [],
                reason: checkRes.reason || 'points_insufficient'
            }
        } else {
            // 请求错误，给一个网络错误弹窗
            throw new Error(checkOriginRes.msg)
        }
    } catch (error: any) {
        console.error('checkUserChatNeedSubscription Error', error)
        const isCanceled =
            error?.msg == 'canceled' ||
            error?.message == 'canceled' ||
            error?.code == 'ERR_CANCELED' ||
            error?.name == 'CanceledError'

        if (isCanceled) {
            return {
                show: false,
                canceled: true
            }
        }

        return {
            show: false
        }
    } finally {
        if (checkUserChatNeedSubscriptionTot) {
            clearTimeout(checkUserChatNeedSubscriptionTot)
            checkUserChatNeedSubscriptionTot = null
        } else {
            $loading.hide()
        }
    }
}
